import React, { useEffect } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import createPerSliceIdSelector from '../../helpers/createPerSliceIdSelector';
import { getSliceContent, getSliceTitleAndTag } from '../../selectors';
import get from '../../helpers/get';
import Title from '../Title';
import { largeTitle as titleStyle } from '../../styles/theme';

const getSliceNumOfCards = createPerSliceIdSelector(getSliceContent, content => get(content, ['number_of_cards']));

const getSliceGender = createPerSliceIdSelector(getSliceContent, content => get(content, ['gender']));

const getSliceRecommendationStrategy = createPerSliceIdSelector(
  getSliceContent,
  content => get(content, ['recommendation_strategy']),
);

const RecommendationsPlaceholder = ({
  cards,
  strategy,
  title,
  titleTag,
  className,
  classes,
  gender,
}) => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    window.isRecommendationsPlaceholderRendered = true;
  }, []);

  return (
    <div className={className} id="recommendations-placeholder">
      <Title className={classes.title} tag={titleTag}>
        {title}
      </Title>
      <div
        data-ti-product-recommendations
        cards={cards}
        strategy={strategy}
        gender={gender}
      />
    </div>
  );
};

RecommendationsPlaceholder.propTypes = {
  cards: PropTypes.number,
  strategy: PropTypes.string.isRequired,
  title: PropTypes.string,
  titleTag: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  gender: PropTypes.string,
};

RecommendationsPlaceholder.defaultProps = {
  cards: 6,
  title: undefined,
  className: undefined,
  titleTag: 'h2',
  gender: null,
};

const mapStateToProps = (state, { sliceId: id }) => ({
  id,
  ...getSliceTitleAndTag(state, id),
  cards: getSliceNumOfCards(state, id),
  gender: getSliceGender(state, id),
  strategy: getSliceRecommendationStrategy(state, id),
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    title: {
      ...titleStyle,
      marginBottom: 3,
    },
  }),
)(RecommendationsPlaceholder);
